/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemDropdownParameter } from './SystemDropdownParameter';
import {
    SystemDropdownParameterFromJSON,
    SystemDropdownParameterFromJSONTyped,
    SystemDropdownParameterToJSON,
    SystemDropdownParameterToJSONTyped,
} from './SystemDropdownParameter';

/**
 * 
 * @export
 * @interface SystemDropdownParameterResponse
 */
export interface SystemDropdownParameterResponse {
    /**
     * 
     * @type {SystemDropdownParameter}
     * @memberof SystemDropdownParameterResponse
     */
    parameter: SystemDropdownParameter;
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownParameterResponse
     */
    value: string;
}



/**
 * Check if a given object implements the SystemDropdownParameterResponse interface.
 */
export function instanceOfSystemDropdownParameterResponse(value: object): value is SystemDropdownParameterResponse {
    if (!('parameter' in value) || value['parameter'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function SystemDropdownParameterResponseFromJSON(json: any): SystemDropdownParameterResponse {
    return SystemDropdownParameterResponseFromJSONTyped(json, false);
}

export function SystemDropdownParameterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemDropdownParameterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'parameter': SystemDropdownParameterFromJSON(json['parameter']),
        'value': json['value'],
    };
}

export function SystemDropdownParameterResponseToJSON(json: any): SystemDropdownParameterResponse {
    return SystemDropdownParameterResponseToJSONTyped(json, false);
}

export function SystemDropdownParameterResponseToJSONTyped(value?: SystemDropdownParameterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parameter': SystemDropdownParameterToJSON(value['parameter']),
        'value': value['value'],
    };
}

